import { LocaleId } from 'intl-lib';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface LocaleState {
  locale: LocaleId;
  hasHydrated: boolean;
}

export interface LocaleAction {
  setLocale: (locale: LocaleId) => void;
  setHasHydrated: (hasHydrated: boolean) => void;
}

/**
 * Global Settings
 */
export const useLocaleStore = create<LocaleState & LocaleAction>()(
  persist(
    set => ({
      locale: 'en-US',
      hasHydrated: false,
      setLocale(locale) {
        set({
          locale,
        });
      },
      setHasHydrated: hasHydrated => {
        set({
          hasHydrated,
        });
      },
    }),
    {
      name: 'com.rockx.stake.settings.locale',
      onRehydrateStorage: state => {
        return () => state.setHasHydrated(true);
      },
    }
  )
);
